/* eslint-disable react/button-has-type, react/jsx-props-no-spreading */
import { Button, Label, Modal, ModalDialog as Dialog } from '@micromag/core/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Avatar from '../partials/Avatar';

const propTypes = {
    author: PropTypes.shape({}),
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    author: null,
    onConfirm: null,
    onCancel: null,
    className: null,
};

const EditorLocked = ({ author, onConfirm, onCancel, className }) => {
    const { name = null, short_name: shortName = null } = author || {};
    const authorName = name || shortName || 'User';

    return (
        <Modal>
            <Dialog
                title={
                    <FormattedMessage defaultMessage="Editing locked" description="Dialog title" />
                }
                className={classNames([
                    'p-2',
                    {
                        [className]: className,
                    },
                ])}
                onClose={onCancel}
            >
                <div className="bg-dark">
                    <div className="mb-3">
                        {author !== null ? <Avatar className="mb-2" {...author} /> : null}
                        <Label>
                            <FormattedMessage
                                defaultMessage="{name} is currently editing this Micromag."
                                description="Confirmation message"
                                values={{ name: authorName }}
                            />
                        </Label>
                    </div>
                    <div>
                        <Button
                            theme="danger"
                            onClick={onConfirm}
                            className="btn-outline-secondary me-2"
                        >
                            <Label>
                                <FormattedMessage
                                    defaultMessage="Take over editor"
                                    description="Button label"
                                />
                            </Label>
                        </Button>
                        <Button
                            onClick={onCancel}
                            theme="primary"
                            label={
                                <FormattedMessage
                                    defaultMessage="Exit editor"
                                    description="Button label"
                                />
                            }
                        />
                    </div>
                </div>
            </Dialog>
        </Modal>
    );
};

EditorLocked.propTypes = propTypes;
EditorLocked.defaultProps = defaultProps;

export default EditorLocked;
